import gql from 'graphql-tag';

export const GET_CLIENT_LOGO_QUERY = gql`
  query GetClientLogo($clientId: String!) {
    getBackendServerClientByClientId(clientId: $clientId) {
      logo_url
    }
  }
`;
